import { z } from 'zod'

import { marketingEntityScopeSchema } from './marketingScope'
import { dbEntitySchema } from './system'
import {
  EmailDomainDnsRecordType,
  EmailDomainProvider,
  EmailDomainStatus,
} from '../constants/emailDomain'

export const emailDomainDnsRecordSchema = z.object({
  type: z.nativeEnum(EmailDomainDnsRecordType),
  host: z.string().min(1),
  value: z.string().min(1),
  priority: z.number().int().positive().nullish(),
  required: z.boolean(),
  verified: z.boolean(),
})

export const emailDomainSchema = dbEntitySchema
  .and(marketingEntityScopeSchema)
  .and(
    z.object({
      domain: z.string().min(1).toLowerCase(),
      status: z.nativeEnum(EmailDomainStatus),
      provider: z.nativeEnum(EmailDomainProvider),
      defaultFromName: z.string().nullish(),
      defaultFromEmail: z.string().email().nullish(),
      replyToEmail: z.string().email().nullish(),
      configurationSet: z.string().nullish(),
      returnPathDomain: z.string().nullish(),
      trackingDomain: z.string().nullish(),
      verifiedAt: z.date().nullish(),
      lastVerificationCheck: z.date().nullish(),
      dnsRecords: z.array(emailDomainDnsRecordSchema).default([]),
      createdBy: z.string().nullish(),
    })
  )

export const emailSenderSchema = dbEntitySchema
  .and(marketingEntityScopeSchema)
  .and(
    z.object({
      emailDomain: z.string().min(1),
      displayName: z.string().min(1),
      email: z.string().email(),
      replyTo: z.string().email().nullish(),
      enabled: z.boolean(),
      default: z.boolean(),
    })
  )

export const emailDomainCreateArgsSchema = marketingEntityScopeSchema.and(
  z.object({
    domain: z.string().min(1).toLowerCase(),
    provider: z
      .nativeEnum(EmailDomainProvider)
      .default(EmailDomainProvider.SES),
    defaultFromName: z.string().nullish().optional(),
    defaultFromEmail: z.string().email().nullish().optional(),
    replyToEmail: z.string().email().nullish().optional(),
    configurationSet: z.string().nullish().optional(),
    returnPathDomain: z.string().nullish().optional(),
    trackingDomain: z.string().nullish().optional(),
    createdBy: z.string().nullish().optional(),
  })
)

export const emailDomainListArgsSchema = marketingEntityScopeSchema.and(
  z.object({
    status: z.nativeEnum(EmailDomainStatus).optional(),
  })
)

export const emailSenderCreateArgsSchema = z.object({
  displayName: z.string().min(1),
  email: z.string().email(),
  replyTo: z.string().email().nullish().optional(),
  enabled: z.boolean().default(true),
  default: z.boolean().default(false),
})

export const emailSenderUpdateArgsSchema = z
  .object({
    displayName: z.string().min(1).optional(),
    email: z.string().email().optional(),
    replyTo: z.string().email().nullish().optional(),
    enabled: z.boolean().optional(),
    default: z.boolean().optional(),
  })
  .refine((args) => Object.keys(args).length > 0, {
    message: 'at least one field must be provided',
  })
